const urls = {
  _INDEX_HTML: 'index.html',
  LOADING: 'loading',
  IDENTIFICATION: 'identification',
  IDENTIFICATION_SUCCESS: 'identification-success',
  CHANGE_PASSWORD: 'change-password',
  CHANGE_PASSWORD_SUCCESS: 'change-password-success',
  _BLANK: ''
};
export const PagesURLs = urls;
